<template>
  <div class="plat-data-grid-semester"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="semesters">
      <template v-if="semesters.length">
        <keep-alive>
          <TemplateDataGrid :key="semester"
                            ref="grid"
                            :gridId="gridId"
                            v-bind="gridParams"
                            v-on="$listeners">
            <template #title="{title}">
              <div class="plat-data-grid-semester-header">
                <span v-if="showLabel"
                      class="custom-label">学期</span>
                <el-select v-model="semester"
                           size="mini"
                           filterable>
                  <el-option v-for="semester in semesters"
                             :key="semester.id"
                             :label="semester.name"
                             :value="semester.id"/>
                </el-select>
                <span v-if="showTitle"
                      class="custom-title">{{title}}</span>
                <div v-if="$slots.append"
                     class="append">
                  <slot name="append"></slot>
                </div>
              </div>
            </template>
          </TemplateDataGrid>
        </keep-alive>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>学期数据为空</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>学期数据加载失败</div>
        <el-button type="text"
                   @click="loadSemesters">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/grid/wrapper'
export default {
  name: 'PlatDataGridSemester',
  mixins: [Wrapper],
  components: {
    TemplateDataGrid,
    Hint
  },
  props: {
    showLabel: Boolean,
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      semesters: null,
      semester: ''
    }
  },
  computed: {
    gridParams () {
      return {
        semester: this.semester
      }
    }
  },
  methods: {
    loadSemesters () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/semesters',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.semesters = response.data['semesters'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadGridData () {
      this.$nextTick(() => {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      })
    }
  },
  mounted () {
    this.loadSemesters()
  },
  watch: {
    semesters: function (val) {
      if (val && val.length) {
        let getSemester = val.find(semester => semester.active)
        if (!getSemester) {
          let lastSemesterId = this.getWrapper('semester')
          if (lastSemesterId) {
            getSemester = val.find(semester => semester.id === lastSemesterId)
          }
        }
        if (getSemester) {
          this.semester = getSemester.id
        } else {
          this.semester = val[0].id
        }
      }
    },
    semester: function (val) {
      this.setWrapper('semester', val)
    },
    gridParams: {
      handler: function () {
        this.loadGridData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .plat-data-grid-semester {
    height: 100%;
    .plat-data-grid-semester-header {
      display: inline-flex;
      align-items: center;
      .el-select {
        width: 132px;
      }
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
      .custom-title {
        margin-left: 8px;
        font-size: 13px;
      }
    }
  }
</style>
